// extracted by mini-css-extract-plugin
module.exports = {"container":"paymentThanksPage_container__3zeGr","title":"paymentThanksPage_title__1FAta","description":"paymentThanksPage_description__m3bO7"};
    if(module.hot) {
      // 1790670300592
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  